import { render, staticRenderFns } from "./Ops-Manager-Visits.vue?vue&type=template&id=3bc0bdb2&"
import script from "./Ops-Manager-Visits.vue?vue&type=script&lang=js&"
export * from "./Ops-Manager-Visits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports